import { Node, NodeProps } from "@xyflow/react"
import { cn } from "design-system/utils"
import { Plus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useWorkflowBuilder } from "../hooks/useWorkflowBuilder"
import { CARD_HEIGHT, CARD_WIDTH } from "../lib/constants"

export function EmptyNode(_props: NodeProps<Node>) {
  const { t } = useTranslation()
  const { onAddWorkflow } = useWorkflowBuilder()

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onAddWorkflow()
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      style={{ height: CARD_HEIGHT, width: CARD_WIDTH }}
      className={cn(
        "nodrag nopan group flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-muted-foreground/40 bg-background/40 p-4 text-center cursor-pointer transition-all pointer-events-auto",
        "hover:border-chart-primary hover:bg-background/80 hover:shadow-md",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      )}
    >
      <div className="flex items-center gap-2 text-foreground">
        <Plus className="size-4" />
        <span className="text-base font-medium">{t("settings.workflows.builderEmpty.title")}</span>
      </div>
      <span className="text-sm text-muted-foreground">
        {t("settings.workflows.builderEmpty.description")}
      </span>
    </button>
  )
}
